import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=3c8151a6&scoped=true&"
import script from "./analysis.vue?vue&type=script&lang=js&"
export * from "./analysis.vue?vue&type=script&lang=js&"
import style0 from "./analysis.vue?vue&type=style&index=0&lang=less&"
import style1 from "./analysis.vue?vue&type=style&index=1&id=3c8151a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8151a6",
  null
  
)

export default component.exports